import { getFeaturedPostsWidgetConfig } from '../../UserWidgets.deviation_gruser/FeaturedPosts/widgetConfig';
import { getPostsFeedWidgetConfig } from '../../UserWidgets.deviation_gruser/PostsFeed/widgetConfig';
import getCoverDeviationWidgetConfig from '../../UserWidgets.deviation_gruser/CoverDeviation/widgetConfig';

export const getPostsWidgetConfigs = ({ t, dispatch }) => ({
  coverDeviation: getCoverDeviationWidgetConfig({ t, dispatch }),
  postsFeed: getPostsFeedWidgetConfig({ t, dispatch }),
  featuredPosts: getFeaturedPostsWidgetConfig({ t, dispatch }),
});
